import * as types from "../../actions/shoppingCart/types";

const initialState = {
    carts: [],
    apiCarts: {},
    storeSelected: null,
};
const shoppingCart = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_DATA_SHOPPING_CART:
            return {...state, [action.name]: action.value};

        case types.ADD_ITEM_IN_SHOPPING_CART:
            const {product, selectGrade, numbers: w_numbers, optionSelect} = action;
            const finalCard = optionSelect
                ? {...product, grades: [selectGrade], w_numbers, optionSelect}
                : {...product, grades: [selectGrade], w_numbers};
            let addCard = [...state.carts];

            if (state.carts.length !== 0) {
                addCard = addCard.filter(itemCard => {
                    if (itemCard.grades[0].gradeId !== finalCard.grades[0].gradeId) {
                        return itemCard;
                    } else {
                        return '';
                    }
                });
                addCard.push(finalCard);
            } else {
                addCard.push(finalCard);
            }
            
            return {...state, carts: addCard};

        case types.CHANGE_API_CARTS_LIST_PRODUCTS_MODAL_SHOPPING_CARD:
            return {...state, apiCarts: action.apiCarts};

        case types.REMOVE_ALL_ITEM_IN_BASKET_CART:
            return {...state, carts: [], apiCarts: {}};

        case types.REMOVE_ITEM_IN_BASKET_CART:
            let newShoppingCart = [];
            let numbersProductRemove = 1;
            state.carts.forEach(card => {
                if (card.grades[0].gradeId !== action.gradeId)
                    newShoppingCart.push(card);
                else {
                    numbersProductRemove = card.w_numbers;
                }
            });


            if(state.apiCarts && state.apiCarts.basket) { // age az safheye modale sabade kharid bezanim hazfe mahsool ke in ejra mishe, vali age az safheye food pack mahsool hazf konim dg in if ejra nmishe
                let newApiCartsBasket = {};
                let priceRemoveItem = 0;
                Object.keys(state.apiCarts.basket).forEach(key => {
                    if (key !== action.gradeId)
                        newApiCartsBasket = {...newApiCartsBasket, [key]: state.apiCarts.basket[key]};
                    else
                        priceRemoveItem = state.apiCarts.basket[key].price;
                });
                
                let newApiCard = {
                    ...state.apiCarts, basket_count: Object.keys(newApiCartsBasket).length,
                    total: (parseInt(state.apiCarts.total) - (parseInt(priceRemoveItem) * numbersProductRemove)),
                    delivery_status:
                        {
                            ...state.apiCarts.delivery_status,
                            price_num: state.apiCarts.delivery_status.price_num === '' ?
                                (parseInt(state.apiCarts.total) - (parseInt(priceRemoveItem) * numbersProductRemove)) < state.apiCarts.delivery_status.min_cost_for_free_delivery
                                    ? state.apiCarts.delivery_status.min_cost_for_free_delivery - (parseInt(state.apiCarts.total) - (parseInt(priceRemoveItem) * numbersProductRemove))
                                    : ''
                                : (state.apiCarts.delivery_status.price_num + (parseInt(priceRemoveItem) * numbersProductRemove)),
                            show: (state.apiCarts.delivery_status.show !== undefined && !state.apiCarts.delivery_status.show) ? false : (state.apiCarts.delivery_status.start_for_show_free_delivery <= (parseInt(state.apiCarts.total) - (parseInt(priceRemoveItem) * numbersProductRemove)))
                        }
                };
                return {...state, carts: newShoppingCart, apiCarts: {...newApiCard, basket: newApiCartsBasket}};
            }
            else   
                return {...state, carts: newShoppingCart};

        case types.REFRESH_MODAL_SHOPPING_CARD:
            return {...initialState, carts: []};

        default:
            return state;
    }
};

export default shoppingCart;
